<template>
    <Dropdown v-model="selectedUser" :options="users" optionLabel="fullName" :filter="true" :placeholder="$t('PARTNER')"
        :showClear="true" @change="$emit('input', selectedUser)" style="width: 22em;">
        <template #value="slotProps">
            <div class="user-item" v-if="slotProps.value">
                <img :src="slotProps.value.imageUrl" />
                <div>{{ slotProps.value.fullName }}</div>
            </div>
            <span v-else>
                {{ slotProps.placeholder }}
            </span>
        </template>
        <template #option="slotProps">
            <div class="user-item">
                <img :src="slotProps.option.imageUrl" />
                <div>{{ slotProps.option.fullName }}</div>
            </div>
        </template>
    </Dropdown>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
    users: {
        type: Array,
        required: true
    }
})

const selectedUser = ref()

</script>

<style lang="scss" scoped>
.p-dropdown {
    width: 14rem;
}

.user-item {
    align-items: center;
    display: flex;
    margin-right: 1.8em;

    img {
        margin-left: 0.8em;
        width: 3em;
        height: 3em;
        margin-right: 0.5rem;
        border-radius: 50%;
    }
}
</style>